import { apiService } from "../services/apiService";
import { ActionTypes } from "../constants/actionTypes";
import { updateLoader } from "./loaderAction";
import _ from "lodash";

export const teamsFetch = (authParams, navigate, handleError) => {
  return async (dispatch) => {
    const filter = {
      page: 1,
      size: 50,
    };
    const response = await apiService.getTeams(authParams, filter);
    const teams = [];
    teams.push(...(response?.data?.teams || []));

    const totalPages = response?.data?.paginationInfo?.numberOfPages || 1;
    const requests = [];

    for (let i = 2; i <= totalPages; i++) {
      requests.push({
        authParams: authParams,
        filter: { ...filter, page: i },
      });
    }

    const requestsChunk = _.chunk(requests, 5);
    for (const chunk of requestsChunk) {
      const resolvedRequests = await Promise.all(
        chunk.map((r) => apiService.getTeams(r.authParams, r.filter))
      );
      for (const item of resolvedRequests) {
        if (item?.status === 200) {
          teams.push(...(item?.data?.teams || []));
        }
        if (item.status !== 200) {
          if (item.status === 401) return navigate("/unauthorized");
          return handleError(item.data);
        }
      }
    }

    dispatch({
      type: ActionTypes.TEAMS_FETCH,
      payload: teams,
    });
  };
};

export const slotsFetch = (authParams, navigate, handleError) => {
  return async (dispatch) => {
    const response = await apiService.getSlots(authParams);
    if (response.status === 200) {
      dispatch(updateLoader({ reconLoading: false }));
      return dispatch({
        type: ActionTypes.SLOTS_FETCH,
        payload:
          response?.data?.settings?.taskSettings?.rescheduleConfig
            ?.staticSlots || [],
      });
    }
    if (response.status === 401) return navigate("/unauthorized");
    handleError(response.data);
  };
};
